import { Outlet, useNavigate } from 'react-router';

import {
  ArrowLeftIcon,
  Button,
  cn,
  ScrollArea,
  ScrollBar,
  Separator,
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@app-evolution-cms/element-ui';

import { THEME, useTheme } from '../../theme-provider';
import { AppSidebar } from './app-sidebar';
import { Breadcrumb } from './breadcrumb';
import { EnvBadge } from './env-badge';

export function Navigation() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="overflow-hidden bg-transparent">
        <header className="sticky top-0 z-10 flex h-14 w-full items-center justify-between gap-2 px-4">
          <div className="flex flex-1 items-center gap-4">
            <SidebarTrigger
              id="PER-navigation-header-sidebarTrigger"
              className={cn('flex-none', {
                'bg-[#91DBA4]!': theme !== THEME.DARK,
              })}
            />
            <Separator className="h-8" orientation="vertical" />
            <Button
              id="PER-navigation-header-goBack"
              className="flex-none"
              variant="secondary"
              size="icon"
              onClick={() => navigate(-1)}
            >
              <ArrowLeftIcon />
            </Button>
            <Breadcrumb />
          </div>
          <div className="flex-none">
            <EnvBadge />
          </div>
        </header>
        <main className="relative h-[calc(100svh-3.5rem)] rounded-none bg-background bg-black/[0.03] bg-blend-multiply inset-shadow-sm md:rounded-tl-[2.2rem] dark:bg-black/20">
          <ScrollArea className="h-full w-full rounded-none md:rounded-tl-[2.2rem]">
            <div id="PER-navigation-main-contentArea" className="relative p-4">
              <Outlet />
            </div>
            <ScrollBar orientation="vertical" />
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
